import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from './Home.js';
import Program from "./Program.js";
import Portfolio from "./Portfolio.js";
import About from "./About.js";
import Jobs from "./Jobs.js"
import NavBar from "./components/NavBar.js";
import Footer from "./components/Footer.js";
import ScrollToTop from "./components/scrollToTop";

function App() {
  return (
    <>
    <div className="site-wrapper">
      
      <Router>
      <ScrollToTop/>
      <NavBar/>
        <Switch>
          <Route exact path="/"> <Home/> </Route>
          <Route exact path="/program"> <Program/> </Route>
          <Route exact path="/about"> <About/> </Route>
          <Route exact path="/portfolio"> <Portfolio/> </Route>
          <Route exact path="/jobs"> <Jobs/> </Route>
        </Switch>
      <Footer/>
      </Router>
      </div>
      
      </>
  );
}

export default App;
